import type {
  AbstractControl,
  ValidationErrors,
  ValidatorFn,
} from '@angular/forms';
import { PeselNumberHelper } from '../helpers';

export const onyxPeselNumberValidator: ValidatorFn = (
  control: AbstractControl,
): ValidationErrors | null => {
  if (!control.value) return null;

  return PeselNumberHelper.isValid(String(control.value))
    ? null
    : { peselNumber: true };
};
